import { useLocation, useParams } from 'react-router';

const mainSectionParameter = (params) => {
  const { mainSection } = params;
  const referenceSection = mainSection === 'reference';
  const inboxSection = mainSection === 'monitor-inbox';
  const searchResultsSection = window.location.pathname.includes('/search-results');
  const mainSectionTitle = inboxSection || referenceSection ? `${inboxSection ? 'Inbox' : 'Reference'} - ` : '';
  return { referenceSection, inboxSection, searchResultsSection, mainSectionTitle };
};

const useMainSectionParameter = () => {
  const location = useLocation();
  const params = useParams();
  const { mainSection } = params;
  const referenceSection = mainSection === 'reference';
  const inboxSection = location.pathname.includes('/monitor-inbox');
  const searchResultsSection = location.pathname.includes('/search-results');
  const priorityUpdatesSection = location.pathname.includes('/priority-updates');
  const dashboardSection = location.pathname.includes('/dashboard');
  const mainSectionTitle = inboxSection || referenceSection ? `${inboxSection ? 'Inbox' : 'Reference'} - ` : '';
  const regulationDocumentSection = location.pathname.includes('/regulation-document');

  return {
    referenceSection,
    inboxSection,
    searchResultsSection,
    mainSectionTitle,
    priorityUpdatesSection,
    dashboardSection,
    regulationDocumentSection,
  };
};

export { useMainSectionParameter, mainSectionParameter };
